import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CorporativeClientService } from './corporative-client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [CorporativeClientService],
})
export class CorporativeClientModule { }
